"use client";
import { useRef as c, useReducer as i, useLayoutEffect as p, useEffect as m, createElement as h } from "react";
import { createPortal as E } from "react-dom";
const y = typeof document < "u" ? p : m;
function C(u) {
  const { children: f, target: s, tag: a, host: d } = u, r = c(null), e = c(null), [, l] = i((t) => t + 1, 0);
  y(() => {
    if (!r.current) return;
    const t = r.current.ownerDocument, o = d ?? t.body;
    return e.current = t.createElement(a ?? "inkeep-portal"), o.appendChild(e.current), l(), () => {
      e.current && o.removeChild(e.current);
    };
  }, []);
  const n = s?.current ?? e.current;
  return n ? E(f, n) : h("span", { ref: r });
}
export {
  C as Portal
};
